import React from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { AnalyticsDashboard } from '../components/trip/AnalyticsDashboard';

export default function TripAnalytics() {
  const { tripId } = useParams();
  const context = useOutletContext();
  const { isOrganizer } = context || {};
  const { t } = useLanguage();

  if (!isOrganizer) {
    return (
      <div className="text-center py-12">
        <p className="text-slate-500 dark:text-slate-400">
          {t('analytics.organizerOnly')}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <AnalyticsDashboard tripId={tripId} />
    </div>
  );
}
